import { render, staticRenderFns } from "./ASLGettingStartedHelpLink.vue?vue&type=template&id=defe155e&scoped=true"
import script from "./ASLGettingStartedHelpLink.vue?vue&type=script&lang=js"
export * from "./ASLGettingStartedHelpLink.vue?vue&type=script&lang=js"
import style0 from "./ASLGettingStartedHelpLink.vue?vue&type=style&index=0&id=defe155e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defe155e",
  null
  
)

export default component.exports